import { Badge, Icon, Icons } from '@silverfort/sf-components';
import * as actions from '../PASActions';
import Tier from './Tier/Tier';
import { useCallback, useState } from 'react';
import DcsServicesDrawer from './Tier/Resources/DcsServicesDrawer';
import { TIER_FIELDS } from '../../../common/fields';

const { DCS_SERVICES } = TIER_FIELDS;

const Tier0 = ({ dispatch, save, fields, settings }) => {
    const [openDcsServicesDrawer, setOpenDcsServicesDrawer] = useState(false);

    const saveDcsConfig = (config) => {
        dispatch({
            type: actions.UPDATE_DOMAIN_CONTROLLER_SERVICES,
            payload: { value: config }
        });
        save();
        setOpenDcsServicesDrawer(false);
    };

    const closeDcDrawer = useCallback(() => setOpenDcsServicesDrawer(false), []);

    const dcs = Object.values(settings.DomainControllersConfigurations).map((dc, index) => (
        <div
            key={`dc_${index}`}
            className="flex whitespace-nowrap h-6 gap-1 pl-1 pr-2 rounded border border-sf-gray-100">
            <div className="content-center">
                <Icon icon={Icons.Server2Dots} />
            </div>
            <div className="content-center text-xs font-normal">{dc.name}</div>
        </div>
    ));

    const dcsNames = Object.values(settings.DomainControllersConfigurations).map((dc) => dc.name);

    return (
        <div>
            <div>
                <div className="pt-4 pb-4 text-12 text-gray-500">
                    Tier 0 resources include all identity management systems. Privileged accounts authenticating to
                    resources in this tier will be considered tier 0 accounts.
                </div>
                <div className="h-12 content-center font-sm font-medium text-14 flex gap-2 items-center">
                    <div>Domain Controllers</div>
                    <div>
                        <Badge
                            text={`${(fields[DCS_SERVICES.ID].value?.protocols ?? []).length} protocols`}
                            iconButtonProps={{
                                icon: Icons.Edit,
                                onClick: () => setOpenDcsServicesDrawer((state) => !state)
                            }}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap pl-2 pr-3 py-2 rounded-lg border border-sf-gray-100 w-full max-h-22 overflow-y-scroll gap-2">
                    {dcs}
                </div>
            </div>
            <Tier
                dispatch={dispatch}
                save={save}
                fields={fields}
                updateAction={actions.UPDATE_TIER0}
                closeDcDrawer={closeDcDrawer}
                isDcDrawerOpen={openDcsServicesDrawer}
            />
            <DcsServicesDrawer
                open={openDcsServicesDrawer}
                dcsNames={dcsNames}
                dcsConfig={fields[DCS_SERVICES.ID].value}
                onClose={() => setOpenDcsServicesDrawer(false)}
                updateDcsConfig={saveDcsConfig}
            />
        </div>
    );
};

export default Tier0;
